import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesProgrammingBrowser: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.52 9.14h28.96v19.81H32V3.05h-1.52v4.57H1.52V3.05H0v25.9h1.52zm0 19.81h28.96v1.53H1.52Z\"/><path fill=\"currentColor\" d=\"M4.57 12.19v13.72h22.86V12.19Zm9.14 7.62h-1.52v1.52h-1.52v1.53H9.14v-1.53h1.53v-1.52h1.52v-1.52h-1.52v-1.53H9.14v-1.52h1.53v1.52h1.52v1.53h1.52Zm9.15 0h-6.1v-1.52h6.1ZM9.14 4.57h1.53V6.1H9.14Zm-3.04 0h1.52V6.1H6.1Zm-3.05 0h1.52V6.1H3.05ZM1.52 1.52h28.96v1.53H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesProgrammingBrowser
